import unescape from 'lodash/unescape';
import React from 'react';
import PropTypes from 'prop-types';
import {DESTINATION_DATA} from 'destination/destination-prop-types';
import DestinationSchema from 'destination/DestinationSchema';

const AirportHero = ({destination, city, isMobile}) => {
    const subtitle = !isMobile
        ? 'Make flying easy with the smarter way to park and travel.'
        : 'Save Money. Save Time. Easy Checkout.';

    return (
        <div className="AirportHero">
            <div className="AirportHero-content">
                <div
                    className="SearchAirport-container"
                    itemScope
                    itemType="http://schema.org/Place"
                >
                    <h1 className="AirportHero-title">
                        {unescape(destination.title)} Parking
                        <meta
                            itemProp="name"
                            content={unescape(destination.title)}
                        />
                    </h1>
                    <DestinationSchema destination={destination} city={city} />
                    <span className="AirportHero-subtitle">{subtitle}</span>
                </div>
                {!isMobile && (
                    <div className="AirportHero-value-props">
                        <div className="AirportHero-value-prop">
                            <span className="AirportHero-icon AirportHero-icon-pricing" />
                            <h3>
                                Compare Daily Pricing
                                <small>and get a great deal</small>
                            </h3>
                        </div>
                        <div className="AirportHero-value-prop">
                            <span className="AirportHero-icon AirportHero-icon-times" />
                            <h3>
                                Check Shuttle Times
                                <small>
                                    so you can get to the terminal on time
                                </small>
                            </h3>
                        </div>
                        <div className="AirportHero-value-prop">
                            <span className="AirportHero-icon AirportHero-icon-ratings" />
                            <h3>
                                See Ratings
                                <small>
                                    from other drivers and park confidently
                                </small>
                            </h3>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

AirportHero.propTypes = {
    destination: PropTypes.shape(DESTINATION_DATA).isRequired,
    city: PropTypes.object.isRequired,
    isMobile: PropTypes.bool,
};

export default AirportHero;
